// src/services/api.js
import axios from 'axios';

const API_URL = 'https://mundiemby.us.to/api';

const api = axios.create({
  baseURL: API_URL,
  withCredentials: false,
  headers: {
    'Content-Type': 'application/json',
  }
});
// Interceptor para añadir token automáticamente a cada petición
api.interceptors.request.use(config => {
  const token = localStorage.getItem('token'); // Token guardado
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => Promise.reject(error));

// Interceptor para manejar errores globalmente
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response) {
      console.error('Error de API:', error.response.status, error.response.data);
    } else {
      console.error('Error de conexión:', error.message);
    }
    return Promise.reject(error);
  }
);

// Servicios personalizados
const peticionesService = {
  // Obtener todas las peticiones (admin)
  getAll: () => api.get('/peticiones'),

  // Obtener peticiones agrupadas (admin)
  getAgrupadas: () => api.get('/peticiones/agrupadas'),

  // Obtener peticiones de un perfil específico
  getByPerfil: (perfilId) => api.get(`/peticiones/${perfilId}`),

  // Crear nueva petición
  create: (data) => api.post('/peticiones', data),

  // Actualizar petición
  update: (id, data) => api.put(`/peticiones/${id}`, data),

  // Eliminar petición
  delete: (id) => api.delete(`/peticiones/${id}`),

  // Actualizar solo el estado
  updateEstado: (id, estado) => api.patch(`/peticiones/${id}/estado`, { estado }),

  // Buscar en TMDB (si tienes este endpoint en backend)
  searchTMDB: (query) => api.get(`/tmdb/search?query=${query}`),

  // Obtener detalles desde TMDB
  getTMDBDetails: (id, type) => api.get(`/tmdb/details/${id}?type=${type}`),
};

// Método para setear el token después del login
export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common['Authorization'];
  }
};

export default api;